import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase
import { storage, db } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { collection, doc, setDoc } from "firebase/firestore";

function CrearColaborador() {
  const navigate = useNavigate();

  // Estados

  const [pictureURL, setPictureUrl] = useState("");
  const [isLoadingPicture, setIsLoadingPicture] = useState(false);

 

  // 📸 Subir foto
  const handlePictureChange = async (e) => {
    setIsLoadingPicture(true);
    const image = e.target.files[0];

    try {
      const storageRef = ref(storage, `colaboradores/images/${image.name}`);
      const snapShot = await uploadBytes(storageRef, image);
      const downloadUrl = await getDownloadURL(snapShot.ref);
      setPictureUrl(downloadUrl);
      console.log("foto gregario", downloadUrl);
      setIsLoadingPicture(false);
    } catch (error) {
      navigate("/error");
    }
  };

  // 🚀 Crear Gregario en Firestore
  const handleCreateGregario = async (e) => {
    e.preventDefault();

    try {
      const colaboradorRef = collection(db, "colaboradores");
      const newColaboradorDocRef = doc(colaboradorRef);

      await setDoc(newColaboradorDocRef, {
        id: newColaboradorDocRef.id,
        foto: pictureURL,
      });

      alert("Colaborador creado correctamente");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="page">
      <section className="general-container">
        <div className="form-container">
          <form>
            <h3>Crear Colaborador</h3>

            {/* Foto */}
            <div className="uploader-pic">
          <h3>Selecciona una imagen</h3>

              <input onChange={handlePictureChange} type="file" />
              <label>Foto Gregario</label>
            </div>

            {isLoadingPicture && <p>Subiendo foto...</p>}

            {pictureURL && (
              <img src={pictureURL} alt="gregario" width={200} className="uploader-img" />
            )}

            <button type="submit" onClick={handleCreateGregario} className="general-btn">
              Crear Colaborador
            </button>
          </form>
        </div>
      </section>
    </div>

  );
}

export default CrearColaborador;